export const seriesTermsTagTypes: string[] = [
  "show",
  "movie",
  "song",
  "band",
  "book",
  "location",
  "person",
  "product",
  "organization",
  "criminal_organization",
  "sports_club",
  "historical_event",
  "people_group",
  "deity",
  "natural_phenomena",
  "software",
  "video_game",
  "machine",
  "currency",
  "extracurricular_activity",
  "word_play",
  "metaphor",
  "idiom",
  "cultural_reference",
  "symbolism",
  'series_domain_specific',
  'quote_from_songs',
  'quote_from_movie',
  'quote_from_book',
  'historical_quote',
]
